import { render, staticRenderFns } from "./TheProduto.vue?vue&type=template&id=6c73a50d&scoped=true"
import script from "./TheProduto.vue?vue&type=script&lang=js"
export * from "./TheProduto.vue?vue&type=script&lang=js"
import style0 from "./TheProduto.vue?vue&type=style&index=0&id=6c73a50d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c73a50d",
  null
  
)

export default component.exports